import type { SwiperOptions } from 'swiper/types';

export function initSwiper(element: HTMLElement, options: SwiperOptions): void {
	Object.assign(element, options);
	(element as HTMLElement & { initialize(): void }).initialize();
}
